<template>
  <div>
    <div class="guide mb-3 body-2">
      <p>
        補償サービスへの加入を推奨しております。<br>
        詳細は<a href="https://netzfukuoka.jp/special_rent_a_car/insurance_car_rental" target="_blank">こちら</a>をご覧ください。
      </p>
    </div>
    <v-radio-group
      class="book-option-radio-group"
      hide-details="false"
      v-model="opts.insuranceid"
    >
      <v-radio
        v-for="item in items"
        :key="item.id"
        :value="item.id"
      >
        <template #label>
          <div class="name">{{item.name}}</div>
          <div v-if="item.price !== 0" class="price">
            <em>{{item.price | comma}}</em>
            <small>円/日</small>
          </div>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import PartBase from '@/mixins/PartBase'

export default {
  name: 'OptInsurances',
  mixins: [
    PartBase
  ],
  props: {
    opts: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
